import { AppRoutes } from '../../common/constants';
import { Box, Button, Card, CardContent, Link, Tab, Tabs } from '@mui/material';
import { JSX, useState } from 'react';
import { NaturalPerson } from '../../common/types/client';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import ClientPageHeaderSummary from '../components/clientPageHeaderSummary';
import Content from '../../common/components/content';
import DetailsStep from './steps/detailsStep';
import Layout from '../../common/components/layout';
import LayoutLoadingState from '../../common/components/layout/layoutLoadingState';
import RatingDetailsStep from './steps/ratingDetailsStep';
import RelatedFnaStep from '../components/clientInfoSteps/relatedFna';
import RelatedPartiesStep from '../components/clientInfoSteps/relatedPartiesStep';

/**
 * Page with the details of a natural person
 */
const NaturalPersonPage = (): JSX.Element => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const { data: client } = useQuery<NaturalPerson>({
    queryKey: [`/NaturalPerson/${id}`],
  });

  if (!client) {
    return <LayoutLoadingState />;
  }

  const breadcrumbs = [
    { label: 'Your Clients', href: AppRoutes.Clients },
    { label: client.roleplayerName },
  ];

  const stepProps = { client };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Content>
        <Box className="flex justify-between items-center">
          <ClientPageHeaderSummary client={client} />
          <Button
            variant="contained"
            component={Link}
            href={`${AppRoutes.NaturalPersons}/${client.roleplayerID}/edit`}
          >
            Edit
          </Button>
        </Box>
        <Tabs
          className="mt-12"
          variant="scrollable"
          scrollButtons="auto"
          value={activeTab}
          onChange={(_, newValue: number): void => setActiveTab(newValue)}
        >
          <Tab label="Details" />
          <Tab label="Rating details" />
          <Tab label="Related parties" />
          <Tab label="Needs analyses" />
          <Tab label="Quotes" disabled />
          <Tab label="Reports" disabled />
        </Tabs>
        <Card>
          <CardContent>
            {activeTab === 0 && <DetailsStep {...stepProps} />}
            {activeTab === 1 && <RatingDetailsStep {...stepProps} />}
            {activeTab === 2 && <RelatedPartiesStep {...stepProps} />}
            {activeTab === 3 && <RelatedFnaStep {...stepProps} />}
          </CardContent>
        </Card>
      </Content>
    </Layout>
  );
};

export default NaturalPersonPage;
